import { useState } from "react";
import first from "../../assets/screens/1.png";
import second from "../../assets/screens/2.png";
import third from "../../assets/screens/3.png";
import fourth from "../../assets/screens/4.png";
import fivth from "../../assets/screens/5.png";
import "./style.css";

const Screenshots = () => {
	const [current, setCurrent] = useState(2);
	const data = [first, second, third, fourth, fivth, first, second, third];

	const prevSlide = () => {
		setCurrent((prev) => (prev === 0 ? data?.length - 1 : prev - 1));
	};

	const nextSlide = () => {
		setCurrent((prev) => (prev === data?.length - 1 ? 0 : prev + 1));
	};

	const getVisibleSlides = () => {
		const total = data.length;
		const indices = [
			(current - 2 + total) % total,
			(current - 1 + total) % total,
			current,
			(current + 1) % total,
			(current + 2) % total,
		];
		return indices;
	};

	return (
		<div className="screenshots" id="Screenshot">
			<p className="title">Checkout Our App Interface Look</p>
			<p className="description">
				FM 90 Valet System is an intelligent valet parking and vehicle
				management application designed to make parking faster, safer, and more
				convenient.
			</p>
			<div>
				<div className="custom-swiper">
					<button className="arrow left" onClick={prevSlide}>
						&#10094;
					</button>
					<div className="slides">
						{getVisibleSlides().map((index, pos) => {
							const isActive = index === current;
							let extraClass = "";
							if (pos === 0 || pos === 1) extraClass = "left-slide";
							if (pos === 3 || pos === 4) extraClass = "right-slide";
							return (
								<div
									key={index}
									className={`slide ${extraClass} ${isActive ? "active" : ""}`}>
									<div
										className={`phone-wrapper ${
											isActive ? "iphone-frame" : ""
										}`}>
										<img src={data[index]} alt={`screenshot-${index}`} />
									</div>
								</div>
							);
						})}
					</div>
					<button className="arrow right" onClick={nextSlide}>
						&#10095;
					</button>
				</div>
				<div className="dots">
					{data.map((_, i) => (
						<span
							key={i}
							className={`dot ${i === current ? "active" : ""}`}
							onClick={() => setCurrent(i)}
						/>
					))}
				</div>
			</div>
		</div>
	);
};
export default Screenshots;
